






















import { Component, Mixins, Prop, Provide, Vue } from 'vue-property-decorator'
import { SubContent7 } from '../types'
import { index2Abc } from '../utils'
import SCRenderBase from './SCRenderBase.vue'
import { SCRenderMixin } from './SCRenderMixin'

@Component({
  components: { SCRenderBase }
})
export default class SCRender7 extends Mixins(SCRenderMixin) {
  public get options() {
    const data = this.data as SubContent7
    if (data.options.length < 2) return []

    let options = this.genOptionsWithAbc(data.options)

    let len = Math.max(options[0].length, options[1].length)
    const ret: string[][] = []
    for (let i = 0; i < len; i++) {
      ret.push([options[0][i], options[1][i]])
    }
    return ret
  }

  public genOptionsWithAbc(options: string[][]) {
    let index = 0
    let ret: string[][] = []
    for (let i = 0; i < options.length; i++) {
      let row: string[] = []
      for (let j = 0; j < options[i].length; j++) {
        row.push(index2Abc(index++) + '. ' + options[i][j])
      }
      ret.push(row)
    }
    return ret
  }
}
